export default "__VITE_ASSET__BU_7$dW7__"